import { FC } from 'react'
import { Text } from '@mantine/core'

const Ellipsis: FC<{ children: string }> = ({ children }) => (
  <Text styles={{ root: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', textAlign: 'center' } }}>
    {children}
  </Text>
)

export default Ellipsis
